import { fetchFreshFacebookAdsetsByCampaign } from "../../services/getAllCampaigns"
import { fetchFreshFacebookCampaigns } from "../../services/getAllCampaigns"
import {
  FormControl,
  Autocomplete,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material"
// import { Button as MuiButton } from "@mui/material" // No longer used
import DuplicateCampaignModal from "../../components/DuplicateCampaignModal/DuplicateCampaignModal.jsx";
import DuplicateAdsetModal from "../../components/DuplicateAdsetModal/DuplicateAdsetModal.jsx";
import { Button } from "@components/Button/Button"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { useEffect, useState } from "react"
import { fetchAdAccounts } from "@services/ml/adAccountsService";
import useFilesAndFolders from "@hooks/useFilesAndFolders"
import { useSelector } from "react-redux"
// import { notify } from "@utils/notify" // No longer used
import useAdSets from "@hooks/useAdSets"
import { useNavigate } from "react-router"
import useUser from "@hooks/useUser"
import useDefaultValues from "@hooks/useDefaultValues"
import useCreativeGrouping from "@hooks/useCreativeGrouping"
import { Loader } from "@components/Loader"
import ProfileMenu from "@components/ProfileMenu/ProfileMenu"
import useAdAccounts from "@hooks/useAdAccounts"
import { getFacebookConnectionStatus } from "@services/auth/getFacebookConnectionStatus"
import { FacebookIcon } from "lucide-react"
import { InititateFacebookAuth } from "@services/initiateFacebookLogin"
import { Chip } from "@components/Chip/Chip"
import useFacebookPages from "@hooks/useFacebookPages"
import { fetchConnectedPages } from "@services/getConnectedPages"
import fetchFreshFacebookAdsets from "@services/getAllAdSets.js";
import { notify } from "@utils/notify.js";

const LaunchNewAdPage = () => {
  const userId = localStorage.getItem("userId")
  const navigate = useNavigate()
  const { handleGetUserById } = useUser()
  const { adAccounts, loading: adAccountsLoading } = useAdAccounts(userId)
  const [fbConnectionStatus, setFbConnectionStatus] = useState(false)
  const [fbConnectionLoading, setFbConnectionLoading] = useState(true)

  // states
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [selectedAdSet, setSelectedAdSet] = useState(null)
  const [adSetsByCampaign, setAdSetsByCampaign] = useState([])
  const [loadingAdSetsByCampaign, setLoadingAdSetsByCampaign] = useState(false)
  const [selectedCreativeLocation, setSelectedCreativeLocation] = useState(null)
  const [activeButton, setActiveButton] = useState(null)
  const [openCampaignModal, setOpenCampaignModal] = useState(false)
  const [openAdSetModal, setOpenAdSetModal] = useState(false)
  const [selectedAdAccount, setSelectedAdAccount] = useState(null)

  // Fresh adsets state
  const [freshAdSets, setFreshAdSets] = useState([])

  // Facebook and Instagram page states
  const [selectedFacebookPage, setSelectedFacebookPage] = useState("")
  const [selectedInstagramPage, setSelectedInstagramPage] = useState("")
  // const [selectedCampaignForDuplicate, setSelectedCampaignForDuplicate] = useState(null)
  // const [duplicateCampaignName, setDuplicateCampaignName] = useState("")
  // const [goLive, setGoLive] = useState(false)
  // const [isDuplicating, setIsDuplicating] = useState(false) // handled in modal
  // const [selectedAdSetForDuplicate, setSelectedAdSetForDuplicate] = useState(null)
  // const [selectedTargetCampaign, setSelectedTargetCampaign] = useState(null)
  // const [duplicateAdSetName, setDuplicateAdSetName] = useState("")
  // const [adSetBudget, setAdSetBudget] = useState("")
  // const [isAdSetDuplicating, setIsAdSetDuplicating] = useState(false) // handled in modal
  const [oneAdPerAdSet, setOneAdPerAdSet] = useState(false)
  const [advancedGroupMapping, setAdvancedGroupMapping] = useState(false)
  // const [selectedAdSetObjective, setSelectedAdSetObjective] = useState(null)
  const [syncedFolderIds, setSyncedFolderIds] = useState([])
  const [syncedFolders, setSyncedFolders] = useState([])
  // const [folderAdAccountMap, setFolderAdAccountMap] = useState({}) // not used
  const [isSwitchingAdAccount, setIsSwitchingAdAccount] = useState(false)

  // Updated states for Facebook and Instagram pages
  const [facebookPages, setFacebookPages] = useState([])
  const [instagramPages, setInstagramPages] = useState([])
  // const [filteredInstagramPages, setFilteredInstagramPages] = useState([]) // not used
  const [showInstagramWarning, setShowInstagramWarning] = useState(false)
  const [noLinkedInstagramWarning, setNoLinkedInstagramWarning] = useState(false)

  // selectors
  const { filesAndFolders } = useSelector((state) => state.filesAndFolders)
  // const { allAdSets } = useSelector((state) => state.allAdSets)
  // const { adSets } = useSelector((state) => state.adSets)
  const { error: adSetsError } = useSelector((state) => state.adSets)
  const { user } = useSelector((state) => state.user)
  const { updateDefaultValueLoading } = useSelector((state) => state.defaultValues)
  const { groupCreativesLoading } = useSelector((state) => state.groupedCreatives)
  const [refreshFacebookLoading, setRefreshFacebookLoading] = useState(false);
  const [refreshAdAccountLoading, setRefreshAdAccountLoading] = useState(false);

  // constants
  const { googleDriveLink } = user ?? {}

  // hooks
  const { handleGetFilesAndFolders, handleGetSyncedFolderIds } = useFilesAndFolders()
  // const { handleGetAdSets, handleGetAllAdSets, handleDuplicateAdSet } = useAdSets()
  const { handleGetDefaultValues, handleUpdateDefaultValues } = useDefaultValues()
  const { handleGroupCreatives } = useCreativeGrouping()
  const { handleGetFacebookPages, handleGetInstagramAccountDetails } = useFacebookPages()
  // Fresh campaigns and adsets state
  const [freshCampaigns, setFreshCampaigns] = useState([])
  const [loadingFreshCampaigns, setLoadingFreshCampaigns] = useState(false)
  const [refreshCampaignsAdsetsLoading, setRefreshCampaignsAdsetsLoading] = useState(false);
  // Unified refresh handler for campaigns and adsets
  const handleRefreshCampaignsAndAdsets = async () => {
    setRefreshCampaignsAdsetsLoading(true);
    if (!userId || !adAccountId) {
      setRefreshCampaignsAdsetsLoading(false);
      notify("User or Ad Account not found. Cannot refresh.", "error");
      return;
    }
    try {
      // Refresh campaigns
      const campaignsRes = await fetchFreshFacebookCampaigns({
        user_id: userId,
        ad_account_id: adAccountId,
        force_refresh: true,
      });
      setFreshCampaigns(campaignsRes?.data || []);

      // Refresh all ad sets for the ad account
      const allAdsetsRes = await fetchFreshFacebookAdsets({
        user_id: userId,
        ad_account_id: adAccountId,
        force_refresh: true,
      });
      setFreshAdSets(allAdsetsRes?.data || []);

      // Refresh ad sets for the selected campaign (if any)
      if (selectedCampaign) {
        const adsetsByCampaignRes = await fetchFreshFacebookAdsetsByCampaign({
          user_id: userId,
          campaign_id: selectedCampaign,
          ad_account_id: adAccountId,
          fetch_ads: true,
        });
        setAdSetsByCampaign(adsetsByCampaignRes?.data || []);
      } else {
        setAdSetsByCampaign([]);
      }

      notify("Campaigns and Ad Sets refreshed successfully", "success");
    } catch (err) {
      console.error("Error refreshing campaigns and ad sets:", err);
      notify("Failed to refresh campaigns and ad sets", "error");
    } finally {
      setRefreshCampaignsAdsetsLoading(false);
    }
  };


  useEffect(() => {
    if (!userId) return
    const storedAdAccountId = localStorage.getItem("adAccountId")
    if (storedAdAccountId && storedAdAccountId !== "undefined") {
      setSelectedAdAccount(storedAdAccountId)
      return
    }
    const defaultAdAccount = adAccounts?.find(account => account.isDefault === true)
    if (defaultAdAccount) {
      setSelectedAdAccount(defaultAdAccount.fbAdAccountId)
      localStorage.setItem("adAccountId", defaultAdAccount.fbAdAccountId)
      localStorage.setItem("adAccountName", defaultAdAccount.fbAdAccountName)
    }
  }, [userId, adAccounts])

  const adAccountId = localStorage.getItem("adAccountId")

  // handlers
  const handleCampaignChange = async (event, newValue) => {
    // Support both id and campaignId from API
    const campaignId = newValue?.id || newValue?.campaignId || null;
    setSelectedCampaign(campaignId)
    if (userId && newValue) {
      handleUpdateDefaultValues(userId, adAccountId, {
        targetCampaignId: campaignId,
      })
      localStorage.setItem("campaignObjective", newValue.objective)
      localStorage.setItem("targetCampaignId", campaignId)
      localStorage.setItem("targetCampaignName", newValue.name)
      // Fetch adsets for selected campaign
      setLoadingAdSetsByCampaign(true);
      try {
        const response = await fetchFreshFacebookAdsetsByCampaign({
          user_id: userId,
          campaign_id: campaignId,
          ad_account_id: adAccountId,
          fetch_ads: true
        });
        setAdSetsByCampaign(response?.data || []);
      } catch (err) {
        console.log(err)
        setAdSetsByCampaign([]);
      }
      setLoadingAdSetsByCampaign(false);
    } else {
      setAdSetsByCampaign([]);
    }
  }

  const handleAdSetChange = (event, newValue) => {
    // Support both id and adsetId from API
    const adsetId = newValue?.id || newValue?.adsetId || null;
    setSelectedAdSet(adsetId)
    localStorage.setItem("targetAdsetId", adsetId)
    localStorage.setItem("targetAdsetName", newValue?.name)
    handleUpdateDefaultValues(userId, adAccountId, {
      targetAdSetId: adsetId,
    })
  }

  const handleCreativeLocationChange = (event, newValue) => {
    // Support both id and folderId from API
    const folderId = newValue?.id || newValue?.folderId || null;
    setSelectedCreativeLocation(folderId)
    if (userId && newValue) {
      handleUpdateDefaultValues(userId, adAccountId, {
        creativeLocationId: folderId,
      })
    }
  }

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked
    setOneAdPerAdSet(isChecked)
    localStorage.setItem("oneAdPerAdSet", isChecked)
  }

  const handleAdvancedGroupMapping = (event) => {
    const isChecked = event.target.checked
    setAdvancedGroupMapping(isChecked)
    localStorage.setItem("advancedGroupMapping", isChecked)
  }

  // Updated Facebook page handler with automatic Instagram page selection
  const handleFacebookPageChange = (e) => {
    const value = e.target.value
    setSelectedFacebookPage(value)

    // Find the selected Facebook page object
    const selectedFbPage = facebookPages.find(page => page.page_id === value)

    // Save Facebook page details to localStorage
    localStorage.setItem("selectedFacebookPageId", value)
    localStorage.setItem("selectedFacebookPageName", selectedFbPage?.name || "")
    localStorage.setItem("selectedPageId", value)

    // Find related Instagram page based on page_id match
    const relatedInstagramPage = instagramPages.find(instaPage => instaPage.page_id === value)

    if (relatedInstagramPage) {
      setSelectedInstagramPage(relatedInstagramPage.insta_id)
      setShowInstagramWarning(false)
      setNoLinkedInstagramWarning(false)

      // Save Instagram page details to localStorage
      localStorage.setItem("selectedInstagramPageId", relatedInstagramPage.insta_id)
      localStorage.setItem("selectedInstagramPageName", relatedInstagramPage.insta_page_name || "")
      localStorage.setItem("selectedInstagramId", relatedInstagramPage.insta_id)
    } else {
      // If no related Instagram page found, clear selection
      setSelectedInstagramPage("")
      setShowInstagramWarning(false)
      setNoLinkedInstagramWarning(true)

      localStorage.removeItem("selectedInstagramPageId")
      localStorage.removeItem("selectedInstagramPageName")
      localStorage.removeItem("selectedInstagramId")
    }
  }

  // Instagram page handler
  const handleInstagramPageChange = (e) => {
    const value = e.target.value
    setSelectedInstagramPage(value)

    // Find the selected Instagram page object
    const selectedInstaPage = instagramPages.find(page => page.insta_id === value)

    // Save Instagram page details to localStorage
    localStorage.setItem("selectedInstagramPageId", value)
    localStorage.setItem("selectedInstagramPageName", selectedInstaPage?.insta_page_name || "")
    localStorage.setItem("selectedInstagramId", value)

    // Show warning if selected Instagram page is not linked to selected Facebook page
    if (selectedInstaPage && selectedInstaPage.page_id !== selectedFacebookPage) {
      setShowInstagramWarning(true)
      setNoLinkedInstagramWarning(false)
    } else {
      setShowInstagramWarning(false)
      setNoLinkedInstagramWarning(false)
    }
  }

  const handleNext = async () => {
    if (!selectedCampaign || !selectedAdSet || !selectedCreativeLocation) {
      alert("Please select all required fields before proceeding.")
      return
    }

    await handleGroupCreatives({
      folder_id: selectedCreativeLocation,
      user_id: userId,
    })
    navigate("/group-creatives")
  }

  const handleButtonClick = (button) => {
    setActiveButton(button)
    if (button === "campaign") {
      setOpenCampaignModal(true)
    } else if (button === "adset") {
      setOpenAdSetModal(true)
    }
  }

  const handleCloseCampaignModal = (result, msg) => {
    setOpenCampaignModal(false)
    if (result === "success") {
      notify(msg, "success")
    } else if (result === "error") {
      notify(msg, "error")
    }
  }

  const handleCloseAdSetModal = (result) => {
    setOpenAdSetModal(false)
    if (result === "success") {
      notify("Ad Set duplicated successfully!", "success")
    } else if (result === "error") {
      notify("Failed to duplicate ad set.", "error")
    }
  }

  // effects

  useEffect(() => {
    if (adSetsError) {
      console.error("Error fetching ad sets:", adSetsError)
    }
  }, [adSetsError])

  useEffect(() => {
    if (googleDriveLink) handleGetFilesAndFolders(googleDriveLink)
  }, [googleDriveLink])

  useEffect(() => {
    async function fetchData(adAccountId) {
      setIsSwitchingAdAccount(true)
      if (adAccountId && userId) {
        try {
          const response = await fetchFreshFacebookAdsets({
            user_id: userId,
            ad_account_id: adAccountId,
          })
          if (response?.data) {
            setFreshAdSets(response.data)
          } else {
            setFreshAdSets([])
          }
        } catch (err) {
          console.log(err)
          setFreshAdSets([])
        }
      }
      setIsSwitchingAdAccount(false)
    }
    fetchData(adAccountId)
  }, [adAccountId, userId])

  // Fetch fresh campaigns from API on page load
  useEffect(() => {
    async function fetchCampaigns() {
      if (!userId || !adAccountId) return;
      setLoadingFreshCampaigns(true);
      try {
        const response = await fetchFreshFacebookCampaigns({
          user_id: userId,
          ad_account_id: adAccountId,
        });
        setFreshCampaigns(response.data || []);
      } catch (err) {
        console.error("Error fetching fresh campaigns:", err);
        setFreshCampaigns([]);
      }
      setLoadingFreshCampaigns(false);
    }
    fetchCampaigns();
  }, [userId, adAccountId]);

  useEffect(() => {
    if (userId) {
      handleGetUserById(userId)
      getConnectedPagesData()
      handleGetFacebookPages()
    }
  }, [userId])

  const getConnectedPagesData = async () => {
    try {
      const response = await fetchConnectedPages({
        user_id: userId,
        force_refresh: false
      })
      if (response?.data?.data?.facebook_pages) {
        setFacebookPages(response.data.data.facebook_pages)
      }
      if (response?.data?.data?.instagram_pages) {
        setInstagramPages(response.data.data.instagram_pages)
      }
    } catch (error) {
      console.error("Error fetching connected pages:", error)
    }
  }

  useEffect(() => {
    if (instagramPages && instagramPages.length > 0) {
      const uniqueIds = new Set()
      const uniqueAccounts = instagramPages.filter(account => {
        if (account?.insta_id && !uniqueIds.has(account.insta_id)) {
          uniqueIds.add(account.insta_id)
          return true
        }
        return false
      })
      uniqueAccounts.forEach((account) => {
        if (account?.insta_id) {
          handleGetInstagramAccountDetails(account.insta_id)
        }
      })
    }
  }, [instagramPages])

  useEffect(() => {
    const storedFacebookPageId = localStorage.getItem("selectedFacebookPageId")

    if (storedFacebookPageId && facebookPages?.length > 0) {
      const pageExists = facebookPages.some(page => page.page_id === storedFacebookPageId)
      if (pageExists) {
        setSelectedFacebookPage(storedFacebookPageId)

        // Find the Facebook page object and save its name
        const selectedFbPage = facebookPages.find(page => page.page_id === storedFacebookPageId)
        if (selectedFbPage) {
          localStorage.setItem("selectedFacebookPageName", selectedFbPage.name)
          localStorage.setItem("selectedPageId", storedFacebookPageId)
        }

        // Find and auto-select related Instagram page
        const relatedInstagramPage = instagramPages.find(instaPage => instaPage.page_id === storedFacebookPageId)
        if (relatedInstagramPage) {
          setSelectedInstagramPage(relatedInstagramPage.insta_id)
          localStorage.setItem("selectedInstagramPageId", relatedInstagramPage.insta_id)
          localStorage.setItem("selectedInstagramPageName", relatedInstagramPage.insta_page_name)
          localStorage.setItem("selectedInstagramId", relatedInstagramPage.insta_id)
          setNoLinkedInstagramWarning(false)
        } else {
          setNoLinkedInstagramWarning(true)
        }
      } else if (facebookPages.length > 0) {
        // Select first Facebook page if stored one doesn't exist
        const firstFbPage = facebookPages[0]
        setSelectedFacebookPage(firstFbPage.page_id)
        localStorage.setItem("selectedFacebookPageId", firstFbPage.page_id)
        localStorage.setItem("selectedFacebookPageName", firstFbPage.name)
        localStorage.setItem("selectedPageId", firstFbPage.page_id)

        // Auto-select related Instagram page for first Facebook page
        const relatedInstagramPage = instagramPages.find(instaPage => instaPage.page_id === firstFbPage.page_id)
        if (relatedInstagramPage) {
          setSelectedInstagramPage(relatedInstagramPage.insta_id)
          localStorage.setItem("selectedInstagramPageId", relatedInstagramPage.insta_id)
          localStorage.setItem("selectedInstagramPageName", relatedInstagramPage.insta_page_name)
          localStorage.setItem("selectedInstagramId", relatedInstagramPage.insta_id)
          setNoLinkedInstagramWarning(false)
        } else {
          setNoLinkedInstagramWarning(true)
        }
      }
    } else if (facebookPages?.length > 0) {
      // No stored selection, select first Facebook page
      const firstFbPage = facebookPages[0]
      setSelectedFacebookPage(firstFbPage.page_id)
      localStorage.setItem("selectedFacebookPageId", firstFbPage.page_id)
      localStorage.setItem("selectedFacebookPageName", firstFbPage.name)
      localStorage.setItem("selectedPageId", firstFbPage.page_id)

      // Auto-select related Instagram page for first Facebook page
      const relatedInstagramPage = instagramPages.find(instaPage => instaPage.page_id === firstFbPage.page_id)
      if (relatedInstagramPage) {
        setSelectedInstagramPage(relatedInstagramPage.insta_id)
        localStorage.setItem("selectedInstagramPageId", relatedInstagramPage.insta_id)
        localStorage.setItem("selectedInstagramPageName", relatedInstagramPage.insta_page_name)
        localStorage.setItem("selectedInstagramId", relatedInstagramPage.insta_id)
        setNoLinkedInstagramWarning(false)
      } else {
        setNoLinkedInstagramWarning(true)
      }
    }
    // Update filtered Instagram pages
    // setFilteredInstagramPages(getFilteredInstagramPages()) // No longer used
  }, [facebookPages, instagramPages])

  useEffect(() => {
    // setFilteredInstagramPages(getFilteredInstagramPages()) // No longer used
  }, [selectedFacebookPage, instagramPages])

  useEffect(() => {
    handleGetDefaultValues(userId, adAccountId)
    handleGetSyncedFolderIds(userId).then((response) => {
      if (response) {
        const { processed_folder_ids, processed_folder_ad_account_map } = response
        // setFolderAdAccountMap(processed_folder_ad_account_map) // No longer used
        setSyncedFolderIds([])
        setSyncedFolders([])
        if (adAccountId) {
          const syncedFolderIds = processed_folder_ids.filter(folderId => processed_folder_ad_account_map[folderId]["fbAdAccountId"] === adAccountId)
          setSyncedFolderIds(syncedFolderIds)
        }
      }
    })
  }, [userId, adAccountId])

  useEffect(() => {
    if (filesAndFolders && syncedFolderIds.length > 0) {
      const syncedFolderObjects = filesAndFolders.filter(
        (folder) =>
          syncedFolderIds.includes(folder.id) &&
          folder.mimeType === "application/vnd.google-apps.folder"
      )
      setSyncedFolders(syncedFolderObjects)
    }
  }, [filesAndFolders, syncedFolderIds])

  useEffect(() => {
    localStorage.removeItem("oneAdPerAdSet")
    setOneAdPerAdSet(false)
    localStorage.removeItem("advancedGroupMapping")
    setAdvancedGroupMapping(false)
  }, [])

  useEffect(() => {
    const checkFacebookConnection = async () => {
      if (userId) {
        try {
          setFbConnectionLoading(true)
          const response = await getFacebookConnectionStatus(userId)
          setFbConnectionStatus(response?.data?.is_connected)
        } catch (error) {
          console.error("Error checking Facebook connection:", error)
          setFbConnectionStatus(false)
        } finally {
          setFbConnectionLoading(false)
        }
      }
    }
    checkFacebookConnection()
  }, [userId])

  const handleConnectFacebook = () => {
    InititateFacebookAuth()
  }

  const handleRefreshButtonClick = async () => {
    setRefreshFacebookLoading(true);
    try {
      const response = await fetchConnectedPages({ user_id: userId, force_refresh: true });
      if (response?.data?.success) {
        if (response?.data?.data?.facebook_pages) {
          setFacebookPages(response.data.data.facebook_pages);
        }
        if (response?.data?.data?.instagram_pages) {
          setInstagramPages(response.data.data.instagram_pages);
        }
        notify("Pages refreshed successfully", "success");
      } else {
        notify("Failed to refresh pages", "error");
      }
    } catch (error) {
      console.error("Error refreshing pages:", error);
      notify("Failed to refresh pages", "error");
    } finally {
      setRefreshFacebookLoading(false);
    }
  }

  const handleAdAccountRefresh = async () => {
    setRefreshAdAccountLoading(true);
    try {
      await fetchAdAccounts(userId, true);
    } catch (err) {
      console.log(err)
      notify('Failed to refresh ad accounts', 'error');
    } finally {
      setRefreshAdAccountLoading(false);
    }
  }

  return (
    <div className="relative flex flex-col min-h-screen px-6 py-10 mx-auto bg-white max-w-7xl">
      {!fbConnectionLoading && !fbConnectionStatus && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/70 backdrop-blur-sm">
          <div className="max-w-md p-8 text-center bg-white rounded-lg shadow-lg">
            <FacebookIcon className="w-16 h-16 mx-auto mb-4 text-blue-600" />
            <h2 className="mb-4 text-2xl font-bold text-gray-800">Meta Connection Required</h2>
            <p className="mb-6 text-gray-600">
              To use the bulk launch ads feature, you need to connect your Meta ad-account first.
            </p>
            <Button
              text="Connect to Meta"
              onClick={handleConnectFacebook}
              className="flex items-center justify-center gap-2 px-6 py-3 mx-auto font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
            />
          </div>
        </div>
      )}
      {(groupCreativesLoading || isSwitchingAdAccount || loadingAdSetsByCampaign) && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm">
          <Loader />
        </div>
      )}
      <div className="flex items-center justify-between pb-3 mb-6 border-b border-gray-200">
        <h1 className="text-2xl font-bold text-gray-700">Launch Ads</h1>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3">
            <button
              type="button"
              className="px-4 py-2 flex items-center gap-2 transition-colors bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium"
              style={{ minWidth: 150, height: 42 }}
              onClick={() => navigate("/ad-templates")}
            >
              <img src="/template.svg" alt="Template" className="w-5 h-5" style={{ display: 'inline-block' }} />
              <span className="text-sm font-medium text-gray-700">Ad Copy Templates</span>
            </button>
            <button
              onClick={() => navigate("/launch-history")}
              className="px-4 py-2 flex items-center gap-2 transition-colors bg-white border border-gray-300 rounded-lg text-[#7C3AED] hover:bg-gray-50 font-medium"
              style={{ minWidth: 150, height: 42 }}
            >
              <img src="/clock.svg" alt="Clock" className="w-5 h-5" />
              <span className="text-sm font-medium">Launch History</span>
            </button>
            {!fbConnectionLoading && (
              <div className="flex items-center gap-3">
                {fbConnectionStatus ? (
                  <Chip
                    variant="active"
                    className="px-4 py-2 flex items-center gap-2 !bg-[#D3EFE2] !text-[#157A3E] h-[42px]"
                  >
                    <FacebookIcon className="w-4 h-4 text-[#1877F2]" />
                    {/* <span className="text-sm font-medium">Meta Connected</span> */}
                  </Chip>
                ) : (
                  <Chip
                    variant="error"
                    className="px-4 py-2 flex items-center gap-2 !bg-[#FDD7D5] !text-[#B52E26] h-[42px]"
                  >
                    <FacebookIcon className="w-4 h-4 text-[#1877F2]" />
                    {/* <span className="text-sm font-medium">Meta Not Connected</span> */}
                  </Chip>
                )}
              </div>
            )}
            {/* <Button
              text="Launch History"
              onClick={() => navigate("/launch-history")}
              className="px-4 py-2 text-gray-700 transition-colors bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
              style={{ minWidth: 150, height: 42 }}
            /> */}
            <Button
              text="Upload Creatives"
              onClick={() => navigate("/creative-selection")}
              className="px-4 py-2 text-gray-700 transition-colors bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
              style={{ height: 42 }}
            />
          </div>
          <ProfileMenu />
        </div>
      </div>
      {/* Account and Page Selection Section */}
      <div className="flex justify-between gap-4 mb-6">
        <div className="flex flex-col w-full max-w-[240px] gap-3">
          <FormControl sx={{ minWidth: 180 }}>
            <InputLabel>Ad Account</InputLabel>
            <div style={{ maxWidth: '240px', width: '100%' }} className="flex items-center gap-2">
              <div className="flex items-center w-full">
                <Select
                  value={selectedAdAccount || ""}
                  onChange={(e) => {
                    const selectedId = e.target.value
                    setSelectedAdAccount(selectedId)
                    localStorage.setItem("adAccountId", selectedId)
                    localStorage.setItem(
                      "adAccountName",
                      adAccounts?.find(
                        (account) => account.fbAdAccountId === selectedId
                      )?.fbAdAccountName
                    )
                  }}
                  label="Ad Account"
                  disabled={adAccountsLoading}
                  sx={{ width: '100%' }}
                >
                  {adAccounts?.map((account) => (
                    <MenuItem
                      key={account.fbAdAccountId}
                      value={account.fbAdAccountId}
                    >
                      {account.fbAdAccountName}
                    </MenuItem>
                  ))}
                </Select>
                <div style={{ flexShrink: 0, width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '8px' }}>
                  <button
                    type="button"
                    className={`flex items-center justify-center w-8 h-8 transition-colors bg-white border border-gray-300 rounded-full shadow-sm hover:bg-gray-100 ${refreshAdAccountLoading ? 'cursor-wait' : ''}`}
                    title="Refresh Ad Accounts"
                    onClick={refreshAdAccountLoading ? undefined : handleAdAccountRefresh}
                    disabled={refreshAdAccountLoading}
                    style={{}}
                  >
                    <img
                      src="/refresh-gray.svg"
                      alt="Refresh"
                      className={`w-5 h-5 ${refreshAdAccountLoading ? 'animate-spin' : ''}`}
                      style={{ transition: 'transform 0.2s' }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </FormControl>
        </div>
        <div className="flex items-start gap-2">
          <div className="flex flex-row items-start gap-2 w-full max-w-[240px]">
            <button
              type="button"
              className={`flex items-center justify-center w-8 h-8 mt-2 transition-colors bg-white border border-gray-300 rounded-full shadow-sm hover:bg-gray-100 ${refreshFacebookLoading ? 'cursor-wait' : ''}`}
              title="Refresh Pages"
              onClick={refreshFacebookLoading ? undefined : handleRefreshButtonClick}
              disabled={refreshFacebookLoading}
            >
              <img
                src="/refresh-gray.svg"
                alt="Refresh"
                className={`w-5 h-5 ${refreshFacebookLoading ? 'animate-spin' : ''}`}
                style={{ transition: 'transform 0.2s' }}
              />
            </button>
            <FormControl sx={{ minWidth: 180 }}>
              <InputLabel>Facebook Page</InputLabel>
              <Select
                value={selectedFacebookPage || ""}
                onChange={handleFacebookPageChange}
                label="Facebook Page"
                disabled={!facebookPages || facebookPages.length === 0}
              >
                {facebookPages?.map((page) => (
                  <MenuItem
                    key={page.page_id}
                    value={page.page_id}
                  >
                    {page.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="flex flex-col w-full max-w-[240px] gap-2">
            <FormControl sx={{ minWidth: 180 }}>
              <InputLabel>Instagram Page</InputLabel>
              <Select
                value={selectedInstagramPage || ""}
                onChange={handleInstagramPageChange}
                label="Instagram Page"
                disabled={!instagramPages || instagramPages.length === 0}
              >
                {instagramPages?.map((page) => (
                  <MenuItem
                    key={page.insta_id}
                    value={page.insta_id}
                  >
                    {page.insta_page_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {selectedFacebookPage && (
              <>
                {noLinkedInstagramWarning && !showInstagramWarning && (
                  <p className="mt-1 text-xs text-gray-500">
                    No Instagram page linked to selected Facebook page
                  </p>
                )}
                {showInstagramWarning && !noLinkedInstagramWarning && (
                  <p className="mt-1 text-xs text-red-500">
                    This Instagram page is not linked with the selected Facebook page
                  </p>
                )}
              </>
            )}
          </div>
          <div className="flex flex-col w-full max-w-[240px] gap-2">
          </div>
        </div>
      </div>
      {/* Main Form Section */}
      <div className="flex flex-col gap-4 p-6 border shadow-inner bg-gray-50 rounded-xl">
        <div className="grid flex-col grid-cols-2 gap-x-10 gap-y-8">
          <div className="flex flex-col items-center">
            <div className="flex items-center w-full">
              <FormControl fullWidth>
                <Button
                  text="Duplicate Campaign"
                  className={`bg-gray-50 text-black border ${activeButton === "campaign"
                    ? "border-indigo-600"
                    : "border-gray-300"
                    } rounded-md px-4 py-2 hover:bg-indigo-600 hover:text-white w-60`}
                  onClick={() => handleButtonClick("campaign")}
                />
              </FormControl>
              <button
                type="button"
                className={`flex items-center justify-center w-8 h-8 transition-colors bg-white border border-gray-300 rounded-full shadow-sm hover:bg-gray-100 ${refreshCampaignsAdsetsLoading ? 'cursor-wait' : ''}`}
                title="Refresh Campaigns & Adsets"
                onClick={refreshCampaignsAdsetsLoading ? undefined : handleRefreshCampaignsAndAdsets}
                disabled={refreshCampaignsAdsetsLoading}
                style={{ marginLeft: '8px' }}
              >
                <img
                  src="/refresh-gray.svg"
                  alt="Refresh"
                  className={`w-5 h-5 ${refreshCampaignsAdsetsLoading ? 'animate-spin' : ''}`}
                  style={{ transition: 'transform 0.2s' }}
                />
              </button>
            </div>
            <div className="mt-4"></div>
            <FormControl fullWidth>
              <Autocomplete
                options={freshCampaigns || []}
                getOptionLabel={(option) => option.name}
                onChange={handleCampaignChange}
                renderOption={(props, option, { selected }) => {
                  // Find index for fallback uniqueness
                  const idx = freshCampaigns.findIndex(c => c === option);
                  return (
                    <li
                      {...props}
                      key={option.id || option.campaignId || (option.name + '-' + idx)}
                      className={`w-full h-[50px] rounded-lg p-3 gap-1 opacity-100 flex items-center box-border ${selected ? 'bg-gray-100' : 'hover:bg-gray-100'}`}
                      onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#F3F4F6'; }}
                      onMouseLeave={e => { e.currentTarget.style.backgroundColor = selected ? '#F3F4F6' : 'inherit'; }}
                    >
                      <span style={{ fontWeight: 500, fontSize: '15px', color: '#1F2937', marginRight: '10px' }}>{option.name || ''}</span>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Target Campaign"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
            <div className="mt-4"></div>
            <FormControl fullWidth>
              <Autocomplete
                options={syncedFolders || []}
                getOptionLabel={(option) => option.name}
                onChange={handleCreativeLocationChange}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    key={option.id || option.folderId || option.name}
                    className={`w-full h-[50px] rounded-lg p-3 gap-1 opacity-100 flex items-center box-border ${selected ? 'bg-gray-100' : 'hover:bg-gray-100'}`}
                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#F3F4F6'; }}
                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = selected ? '#F3F4F6' : 'inherit'; }}
                  >
                    <span style={{ fontWeight: 500, fontSize: '15px', color: '#1F2937', marginRight: '10px' }}>{option.name || ''}</span>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Synced Creatives"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </div>

          {/* Right column */}
          <div className="flex flex-col items-center">
            <FormControl fullWidth>
              <Button
                text="Duplicate Ad Sets"
                className={`bg-gray-50 text-black border ${activeButton === "adset"
                  ? "border-indigo-600"
                  : "border-gray-300"
                  } rounded-md px-4 py-2 hover:bg-indigo-600 hover:text-white w-60`}
                onClick={() => handleButtonClick("adset")}
                disabled={!selectedCampaign}
                style={{
                  backgroundColor: !selectedCampaign ? '#F3F3F3' : undefined,
                  color: !selectedCampaign ? '#D1D5DB' : undefined,
                  cursor: !selectedCampaign ? 'not-allowed' : 'pointer'
                }}
              />
            </FormControl>
            <div className="mt-4"></div>
            <FormControl fullWidth>
              <Autocomplete
                options={adSetsByCampaign || []}
                loading={loadingAdSetsByCampaign}
                getOptionLabel={(option) => `${option.name} (${option?.adsCount || 0} ads)`}
                onChange={handleAdSetChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Target Ad Set"
                    variant="outlined"
                    InputProps={params.InputProps}
                  />
                )}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.id || option.adsetId || option.name}
                    style={{ padding: 0 }}
                  >
                    <span style={{
                      display: 'block',
                      padding: '12px',
                      borderRadius: '4px',
                      fontWeight: 500,
                      fontSize: '15px',
                      lineHeight: '140%',
                      letterSpacing: '0em',
                      width: '100%',
                      transition: 'background 0.2s',
                    }}>
                      {`${option.name} (${option?.adsCount || 0} ads)`}
                    </span>
                  </li>
                )}
              />
            </FormControl>
            <div className="mt-4"></div>
            <FormControl fullWidth>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={oneAdPerAdSet}
                    onChange={handleCheckboxChange}
                    color="primary"
                  />
                }
                label="Launch 1 Ad per Ad Set"
                className="text-gray-600"
              />
            </FormControl>
            <FormControl fullWidth>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={advancedGroupMapping}
                    onChange={handleAdvancedGroupMapping}
                    color="primary"
                  />
                }
                label="Advanced Mapping"
                className="text-gray-600"
              />
            </FormControl>
          </div>
        </div>
        <div className="mx-auto my-4">
          <Button
            text={"Next"}
            className="text-lg text-white bg-indigo-600 w-60 hover:bg-indigo-700"
            onClick={handleNext}
            loading={updateDefaultValueLoading}
            disabled={updateDefaultValueLoading}
          />
        </div>
      </div>
      {/* Campaign Modal */}
      <DuplicateCampaignModal
        open={openCampaignModal}
        onClose={handleCloseCampaignModal}
        adsets={freshAdSets}
        campaigns={freshCampaigns}
        loadingCampaigns={loadingFreshCampaigns}
        refreshCampaigns={async () => {
          setLoadingFreshCampaigns(true);
          try {
            const response = await fetchFreshFacebookCampaigns({
              user_id: userId,
              ad_account_id: adAccountId,
              "force_refresh": false
            });
            setFreshCampaigns(response?.data || []);
          } catch (err) {
            console.log(err)
            setFreshCampaigns([]);
          }
          setLoadingFreshCampaigns(false);
        }}
      />
      {/* Ad Set Modal */}
      <DuplicateAdsetModal
        open={openAdSetModal}
        onClose={handleCloseAdSetModal}
        adsets={freshAdSets}
        adAccountId={adAccountId}
        loadingAdsets={false}
        adsetsByCampaign={adSetsByCampaign}
        refreshAdsets={async () => {
          if (adAccountId && userId) {
            try {
              const response = await fetchFreshFacebookAdsets({
                user_id: userId,
                ad_account_id: adAccountId,
                "force_refresh": false
              })
              setFreshAdSets(response?.data || [])
              if (selectedCampaign) {
                const adsetsByCampaignRes = await fetchFreshFacebookAdsetsByCampaign({
                  user_id: userId,
                  campaign_id: selectedCampaign,
                  ad_account_id: adAccountId,
                  fetch_ads: true
                });
                setAdSetsByCampaign(adsetsByCampaignRes?.data || []);
              } else {
                setAdSetsByCampaign([]);
              }
            } catch (err) {
              console.log(err)
              setFreshAdSets([])
            }
          }
        }}
        selectedCampaign={freshCampaigns.find(c => c.id === selectedCampaign || c.campaignId === selectedCampaign) || null}
      />
    </div>
  )
}

export default LaunchNewAdPage
